import React, { useRef } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import PsaFormDispatcher, { PsaFormHandle } from "../forms/PsaFormDispatcher";
import RefreshSettings from "../RefreshSettings/RefreshSettings";
import { ResolvedIntegration } from "../types/PsaProject";
import useStyles from "../styles/useStyles";

interface Props {
  projectId: string;
  integration: ResolvedIntegration;
  canManage: boolean;
}

const New: React.FC<Props> = ({ projectId, integration, canManage }) => {
  const styles = useStyles();
  const submitRef = useRef<PsaFormHandle>(null);

  return (
    <div className={styles.page}>
      <Card className={styles.card}>
        <Card.Header className={styles.cardHeader}>
          <Row className={styles.headerRow}>
            <Col sm={1}>
              <Button
                className="btnSeawhite"
                onClick={() =>
                  window.location.assign(`/projects/${projectId}/edit`)
                }
              >
                Cancel
              </Button>
            </Col>
            <Col className={styles.title} sm={9}>
              Push to PSA Project
            </Col>
            {canManage && (
              <Col>
                <Button
                  className="squareGreenButton floatRight"
                  onClick={() => submitRef.current?.save()}
                >
                  Submit
                </Button>
              </Col>
            )}
          </Row>
        </Card.Header>
        <hr className={styles.hr} />
        <Card.Body>
          <RefreshSettings integration={integration} canRefresh={canManage} />
          <PsaFormDispatcher
            ref={submitRef}
            integration={integration}
            projectId={projectId}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default New;
